
<form *ngIf="list.form.controls.booleanFilters" [formGroup]="list.form">
  <div class="row">
    <div class="col pb-2" formArrayName="booleanFilters">
      <div class="form-group form-check" *ngFor="let filter of list.booleanFilters; let i = index" [formGroupName]="i">
        <input class="form-check-input" type="checkbox" formControlName="value" autoLinkToLabel (change)="list.booleanFilterChanged()">
        <label class="form-check-label">{{ filter.caption }}</label>
      </div>
    </div>
  </div>
</form>